/* Insert a space before every group of three digits, starting from the end of the string. */
export function chunkNumbers(value: number | string | undefined) {
  const pattern = /\B(?=(\d{3})+(?!\d))/g

  if (value === undefined) {
    return ''
  }

  if (typeof value === 'string') {
    return value.replace(pattern, ' ')
  }

  return value.toString().replace(pattern, ' ')
}
